import { InfluencingFactorIcon, InfluencingFactorIconGlyph } from "./influencing-factor-icon";
export var SubTopicIcon = InfluencingFactorIcon;
export var SubTopicIconGlyph = InfluencingFactorIconGlyph;